export const MeteringModeIdentifier: Record<number, string> = {
  0: "Unknown",
  1: "Average",
  2: "Center-weighted average",
  3: "Spot",
  4: "Multi-spot",
  5: "Multi-segment",
  6: "Partial",
  7: "Other",
};

export const FlashSettingIdentifier: Record<number, string> = {
  1: "No flash",
  2: "Fired",
  3: "Fired, return not detected",
  4: "Fired, return detected",
  5: "On, did not fire",
  6: "On, fired",
  7: "On, return not detected",
  8: "On, return detected",
  9: "Off, did not fire",
  10: "Off, did not fire, return not detected",
  11: "Auto, did not fire",
  12: "Auto, fired",
  13: "Auto, fired, return not detected",
  14: "Auto, fired, return detected",
  15: "No flash function",
  16: "Off, no flash function",
  17: "Fired, red-eye reduction",
  18: "Fired, red-eye reduction, return not detected",
  19: "Fired, red-eye reduction, return detected",
  20: "On, red-eye reduction",
  21: "On, red-eye reduction, return not detected",
  22: "On, red-eye reduction, return detected",
  23: "Off, red-eye reduction",
  24: "Auto, did not fire, red-eye reduction",
  25: "Auto, fired, red-eye reduction",
  26: "Auto, fired, red-eye reduction, return not detected",
  27: "Auto, fired, red-eye reduction, return detected",
  28: "Other",
};

export const WhiteBalanceIdentifier: Record<number, string> = {
  1: "Auto",
  2: "Manual",
  3: "Other",
};

export const ColorSpaceIdentifier: Record<number, string> = {
  1: "sRGB",
  2: "Adobe RGB",
  3: "Wide Gamut RGB",
  4: "ICC Profile",
  5: "Uncalibrated",
  6: "Other",
};

export const OrientationIdentifier: Record<number, string> = {
  1: "Horizontal (normal)",
  2: "Mirror horizontal",
  3: "Rotate 180",
  4: "Mirror vertical",
  5: "Mirror horizontal and rotate 270 CW",
  6: "Rotate 90 CW",
  7: "Mirror horizontal and rotate 90 CW",
  8: "Rotate 270 CW",
};
